import { requestBuilder } from '../../http/RequestBuilder';
import type { Disclosure } from '../types/BankAccount';

interface UpdateAutoPayBody {
    autoPayEnabled: boolean;
    disclosures?: Disclosure[];
}

export const useUpdateAutoPay = requestBuilder.mutation<
    { success: true },
    UpdateAutoPayBody,
    { syncteraAccountId: string }
>({
    endpoint: ({ syncteraAccountId }) =>
        `/api/bank-accounts/account/auto-pay/${syncteraAccountId}`,
    method: 'PATCH',
});

export default useUpdateAutoPay;
